import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import AboutPage from '../AboutPage/AboutPage';
import ServicePages from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import ShopPage from '../ShopPage'
import ProductSinglePage from '../ProductSinglePage';
import CartPage from '../CartPage';
import CheckoutPage from '../../components/Checkout/CheckoutPage';
import OrderRecived from '../OrderRecived';
import OrderSuccessPage from '../../components/OrderSuccess/OrderSuccessPage';
import PricingPage from '../PricingPage/PricingPage';
import BlogPage from '../BlogPage/BlogPage'
import BlogDetails from '../BlogDetails/BlogDetails'
import BlogTagPage from '../BlogTagPage/BlogTagPage'
import ContactPage from '../ContactPage/ContactPage';
import PrivacePage from '../PrivacePage/PrivacePage';
import TermsPage from '../TermsPage/TermsPage';
import FaqPages from '../faqPages/faqPages';
import ErrorPage from '../ErrorPage/ErrorPage';
import Landing from '../Landing/Landing';
import LoginPage from '../LoginPage';
import RegisterPage from '../RegisterPage';
import ForgotPasswordPage from '../ForgotPasswordPage';
import ResetPasswordPage from '../ResetPasswordPage';
import MyOrdersPage from '../MyOrdersPage';
import OrderDetailPage from '../OrderDetailPage';
import AccountPage from '../AccountPage';
import ProtectedRoute from '../../components/ProtectedRoute';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="home-2" element={<HomePage2 />} />
          <Route path="come-funziona" element={<HomePage2 />} />
          <Route path="shop" element={<ShopPage />} />
          <Route path='shop-single/:slug' element={<ProductSinglePage />} />
          <Route path='cart' element={<CartPage />} />
          <Route path='order_received' element={<OrderRecived />} />
          <Route path="service" element={<ServicePages />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="pricing" element={<Navigate to="/kleeo/la-rivoluzione-pulita" replace />} />
          <Route path="kleeo/:slug" element={<ServiceSinglePage />} />
          <Route path='blog' element={<BlogPage />} />
          <Route path='blog/tag/:tag' element={<BlogTagPage />} />
          <Route path='blog-single/:slug' element={<BlogDetails />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path="privace" element={<PrivacePage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="faq" element={<FaqPages />} />
          <Route path='404' element={<ErrorPage />} />
          <Route path='landing' element={<Landing />} />

          {/* Auth routes */}
          <Route path='login' element={<LoginPage />} />
          <Route path='register' element={<RegisterPage />} />
          <Route path='forgot-password' element={<ForgotPasswordPage />} />
          <Route path='reset-password' element={<ResetPasswordPage />} />

          {/* Protected routes - richiedono autenticazione */}
          <Route path='checkout' element={
            <ProtectedRoute><CheckoutPage /></ProtectedRoute>
          } />
          <Route path='order-success/:orderId' element={
            <ProtectedRoute><OrderSuccessPage /></ProtectedRoute>
          } />
          <Route path='orders' element={
            <ProtectedRoute><MyOrdersPage /></ProtectedRoute>
          } />
          <Route path='orders/:orderId' element={
            <ProtectedRoute><OrderDetailPage /></ProtectedRoute>
          } />
          <Route path='account' element={
            <ProtectedRoute><AccountPage /></ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
